import React from "react";
import { useField } from "formik";
import styled from "styled-components";

type Option = {
  value: string | number;
  label: string;
};

type Props = {
  label: string;
  name: string;
  options: Option[];
  placeholder?: string;
};

// Styled Components
const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 20px;
`;

const Label = styled.label`
  font-size: 16px;
  font-weight: 500;
  color: #091c00;
  line-height: 21.86px;
  font-family: "Manrope", sans-serif;
`;

const Select = styled.select<{ hasError: boolean }>`
  border: ${(props) =>
    props.hasError ? "2px solid #FF5E65" : "0.5px solid #CCCCCC"};
  border-radius: 4px;
  background: transparent;
  padding: 12px 16px;
  outline: none;
  font-family: "Manrope", sans-serif;
  // appearance: none; // to hide dropdown arrow

  option {
    background: #ffffff;
    color: #091c00;
    font-size: 14px;
    padding: 8px 12px;
    font-family: "Manrope", sans-serif;
  }
`;

const ErrorText = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #d91f27;
  font-family: "Sora", sans-serif;
`;

const SelectDropdownField: React.FC<Props> = ({
  label,
  options,
  placeholder,
  ...props
}) => {
  const [field, meta] = useField(props);
  return (
    <FieldWrapper>
      <Label htmlFor={props.name}>{label}</Label>
      <Select
        {...field}
        {...props}
        id={props.name}
        hasError={meta.touched && !!meta.error}
      >
        {placeholder && (
          <option value="" style={{ color: "rgba(9, 28, 0, 0.6) !important" }}>
            {placeholder}
          </option>
        )}
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </Select>
      {meta.touched && meta.error ? <ErrorText>{meta.error}</ErrorText> : null}
    </FieldWrapper>
  );
};

export default SelectDropdownField;
